import {UsersBase} from "./UsersBase";
import {Form} from 'antd';

class UsersManageApp extends UsersBase {

    customButtons() {
        return "";
    }
}

const UsersManage = Form.create()(UsersManageApp);
export default UsersManage;


// WEBPACK FOOTER //
// ./src/app/views/users/UsersManage.js